import React from "react";

function CountDown() {
  return (
    <div>
      <section className="countdown-wrapper bg-white">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-5 g-lg-4">
            <div className="col-12 col-lg-6">
              <div className="pe-lg-5">
                <div className="section-heading">
                  <div className="sub-title">
                    <img src="assets/img/core-img/hammer.png" alt="" />
                    Countdown
                  </div>
                  <h2 className="mb-4">
                    Unlock the Advantage With Insider Insights!
                  </h2>
                  <p className="mb-5">
                    Fill unto likeness had shall is herb air set midst land in
                    meat green had creepeth days bearing winged together malea
                    moving also two replenish spirit set moving. All moving give
                    form deep.
                  </p>
                </div>

                {/* Progress Bar */}
                <div
                  className="progress-container mb-4 wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="500ms"
                >
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="progress-label lh-1">Business Growth</div>
                    <div className="progress-percentage counter lh-1">80%</div>
                  </div>
                  <div className="progress-bar">
                    <div className="progress-fill" data-percentage="80"></div>
                  </div>
                </div>

                {/* Progress Bar */}
                <div
                  className="progress-container wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="700ms"
                >
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="progress-label lh-1">Market Analysis</div>
                    <div className="progress-percentage counter lh-1">90%</div>
                  </div>
                  <div className="progress-bar">
                    <div className="progress-fill" data-percentage="90"></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="stats-container">
                <div
                  className="stat-box wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="500ms"
                >
                  <h2>
                    <span className="counter">450</span>
                  </h2>
                  <p className="mb-0">Projects Done</p>
                </div>
                <div
                  className="stat-box wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="700ms"
                >
                  <h2>
                    <span className="counter">90</span>k
                  </h2>
                  <p className="mb-0">Happy Customers</p>
                </div>
                <div
                  className="stat-box wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="900ms"
                >
                  <h2>
                    <span className="counter">110</span>+
                  </h2>
                  <p className="mb-0">Total Members</p>
                </div>
                <div
                  className="stat-box wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="1100ms"
                >
                  <h2>
                    <span className="counter">99</span>%
                  </h2>
                  <p className="mb-0">Client Satisfaction</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default CountDown;
